export enum ThemeType {
  all = 'all',
  commentary = 'commentary',
  dealFlow = 'dealFlow',
}

export enum ThemeSubtype {
  all = 'all',
  abs = 'abs',
  clo = 'clo',
  close = 'close',
  cmbs = 'cmbs',
  general = 'general',
  mAndA = 'mAndA',
  midday = 'midday',
  open = 'open',
  retail = 'retail',
  rmbs = 'rmbs',
  ssa = 'ssa',
  tenders = 'tenders',
}
